<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent:0em;">Liane Bayliss currently resides in Northamptonshire with her husband and three children.</p><br/>
<p style="text-indent:0em;">Her love of writing was firmly engraved with the gift of her first typewriter when she was seven years old.</p><br/>
<p style="text-indent:0em;"><em>Betrayal</em> is Liane’s first novel.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?11824974